import { useEffect, useState } from 'react';

const useMedias = () => {
  const [isSmallMobile, setIsSmallMobile] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isTablet, setIsTablet] = useState<boolean>(false);
  const [isDesktop, setIsDesktop] = useState<boolean>(false);
  const [isBigDesktop, setIsBigDesktop] = useState<boolean>(false);

  useEffect(() => {
    // set initial value
    const mediaWatcherSmallMobile = window.matchMedia('(max-width: 407px)');
    const mediaWatcherMobile = window.matchMedia('(min-width: 408px) and (max-width: 767px)');
    const mediaWatcherTablet = window.matchMedia('(min-width: 768px) and (max-width: 1199px )');
    const mediaWatcherDesktop = window.matchMedia('(min-width: 1200px) and (max-width: 1599px )');
    const mediaWatcherBigDesktop = window.matchMedia('(min-width: 1600px)');
    setIsSmallMobile(mediaWatcherSmallMobile.matches);
    setIsMobile(mediaWatcherMobile.matches);
    setIsTablet(mediaWatcherTablet.matches);
    setIsDesktop(mediaWatcherDesktop.matches);
    setIsBigDesktop(mediaWatcherBigDesktop.matches);

    //watch for updates
    function updateIsSmallMobile(e) {
      setIsSmallMobile(e.matches);
    }
    function updateIsMobile(e) {
      setIsMobile(e.matches);
    }
    function updateIsTablet(e) {
      setIsTablet(e.matches);
    }
    function updateIsDesktop(e) {
      setIsDesktop(e.matches);
    }
    function updateIsBigDesktop(e) {
      setIsBigDesktop(e.matches);
    }

    mediaWatcherSmallMobile.addEventListener('change', updateIsSmallMobile);
    mediaWatcherMobile.addEventListener('change', updateIsMobile);
    mediaWatcherTablet.addEventListener('change', updateIsTablet);
    mediaWatcherDesktop.addEventListener('change', updateIsDesktop);
    mediaWatcherBigDesktop.addEventListener('change', updateIsBigDesktop);

    // clean up
    return function cleanup() {
      mediaWatcherSmallMobile.removeEventListener('change', updateIsSmallMobile);
      mediaWatcherMobile.removeEventListener('change', updateIsMobile);
      mediaWatcherTablet.removeEventListener('change', updateIsTablet);
      mediaWatcherDesktop.removeEventListener('change', updateIsDesktop);
      mediaWatcherBigDesktop.removeEventListener('change', updateIsBigDesktop);
    };
  }, []);

  return { isSmallMobile, isMobile, isTablet, isDesktop, isBigDesktop };
};

export default useMedias;
